import React, { useEffect, useRef } from "react";

const AddressAutocomplete = ({ isLoaded, loadError, onPlaceSelect }) => {
  const containerRef = useRef(null);
  const elementRef = useRef(null);
  const listenerRef = useRef(null);

  useEffect(() => {
    if (!isLoaded || !window.google?.maps?.places || !containerRef.current) return;

    const placeAutocomplete =
      new window.google.maps.places.PlaceAutocompleteElement({
        includedPrimaryTypes: ["geocode"],
      });

    placeAutocomplete.style.width = "100%";
    placeAutocomplete.style.display = "block";
    placeAutocomplete.style.minHeight = "44px";
    placeAutocomplete.setAttribute("placeholder", "Search address...");
    placeAutocomplete.setAttribute("requested-region", "us");

    const handleSelect = async (event) => {
      try {
        const placePrediction = event.placePrediction;
        if (!placePrediction?.toPlace) return;

        const place = placePrediction.toPlace();

        await place.fetchFields({
          fields: ["formattedAddress", "location"],
        });

        const lat = place.location?.lat?.();
        const lng = place.location?.lng?.();

        if (typeof lat !== "number" || typeof lng !== "number") return;

        onPlaceSelect?.({
          lat,
          lng,
          formattedAddress: place.formattedAddress || "",
        });
      } catch (error) {
        console.error("Place autocomplete selection failed:", error);
      }
    };

    placeAutocomplete.addEventListener("gmp-select", handleSelect);

    containerRef.current.innerHTML = "";
    containerRef.current.appendChild(placeAutocomplete);

    elementRef.current = placeAutocomplete;
    listenerRef.current = handleSelect;

    return () => {
      if (elementRef.current && listenerRef.current) {
        elementRef.current.removeEventListener("gmp-select", listenerRef.current);
      }
      if (containerRef.current) {
        containerRef.current.innerHTML = "";
      }
    };
  }, [isLoaded, onPlaceSelect]);

  if (loadError) {
    return (
      <input
        type="text"
        placeholder="Address search unavailable"
        disabled
        style={{
          width: "100%",
          padding: "10px 12px",
          borderRadius: "10px",
          border: "1px solid #ccc",
          background: "#f5f5f5",
        }}
      />
    );
  }

  if (!isLoaded) {
    return (
      <input
        type="text"
        placeholder="Loading address search..."
        disabled
        style={{
          width: "100%",
          padding: "10px 12px",
          borderRadius: "10px",
          border: "1px solid #ccc",
          background: "#fafafa",
        }}
      />
    );
  }

  return <div ref={containerRef} style={{ width: "100%" }} />;
};

export default AddressAutocomplete;